export default __webpack_public_path__ + "images/ce013430830c1a574a6378adb4d7aafd.png";